<template>
  <div class="page-content" id="tos-form">
    <Titlebar :incrustation="'fa-file-text-o'">
      <h1>{{ pageTitle }}</h1>
    </Titlebar>
    <div class="alert alert-info my-4">
      <p
        v-html="
          $t('tos.description.content', {
            univers: Utils().getApplicationName(),
          })
        "
        class="m-0"
      ></p>
    </div>
    <div class="row">
      <div class="col-4">
        <UiCard>
          <div class="form-row row">
            <label class="col-4">{{ $t("tos.form.title") }}</label>
            <input
              type="text"
              class="form-input col"
              v-model="tos.title"
              name="title"
              v-validate
              data-vv-rules="required"
              :data-vv-as="$t('identification.title')"
              data-vv-validate-on="none"
            />
            <span
              class="form-input-error"
              v-show="showErrors['title'] && errors.has('title')"
              @click="hideError('title')"
              >{{ errors.first("title") }}</span
            >
          </div>
          <div class="form-row row">
            <label class="col-4"
              >{{ $t("tos.form.active") }}
              <!-- TOOLTIP -->
              <span style="position: relative; margin-left: 10px">
                <i
                  class="fa fa-question-circle text-warning warning-beepiz-remote-monitoring show"
                ></i>
                <div
                  class="tooltip left"
                  style="width: 250px; top: -2px; left: 37px"
                >
                  <h5 style="color: #ffc107; font-weight: 700">
                    {{ $t("tos.tooltip.title") }}
                  </h5>
                  {{
                    $t("tos.tooltip.content", {
                      univers: Utils().getApplicationName(),
                    })
                  }}
                </div>
              </span>
              <!-- TOOLTIP END-->
            </label>
            <div class="col" style="padding: 0">
              <UiSwitch v-model="tos.active" />
            </div>
          </div>
        </UiCard>
      </div>
      <div class="col-8 full-height">
        <UiCard>
          <div class="form-row row full-height">
            <UiEditor
              ref="editor"
              @eventEditorUpdated="contentEditorUpdated"
              class="col-12 full-height"
              :contentparent="tos.content"
              :isInvalid="showErrors.content"
            />
            <span
              class="form-input-error"
              v-show="showErrors['content'] && errors.has('content')"
              style="bottom: auto; top: -10px; right: 30px"
              @click="hideError('content')"
            >
              {{ errors.first("content") }}
            </span>
          </div>
        </UiCard>
        <div class="mt-4 d-flex justify-content-between">
          <div>
            <input
              id="checkbox-force-display"
              type="checkbox"
              v-model="forceDisplay"
              :disabled="!tos.active"
            />
            <label for="checkbox-force-display" :class="['pl-2', !tos.active ? 'text-black-50' : '']">{{
              $t("tos.form.forceDisplay")
            }}</label>
          </div>

          <Btn class="primary" @click.native.prevent="validForm">
            <span>{{ $t("global.save") }}</span>
          </Btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/services/API.js";
import Utils from "@/services/utils.js";
import FormUtils from "@/services/form.js";
import axios from "axios";
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import UiCard from "@/components/ui/Card";
import UiEditor from "@/components/ui/Editor";
import UiSwitch from "@/components/ui/Switch";

import { mixin as clickaway } from "vue-clickaway";
import {useDvFlagAccess} from "../../services/featureFlag";

export default {
  name: "TOSForm",
  components: {
    Titlebar,
    Toolbar,
    Btn,
    UiCard,
    UiEditor,
    UiSwitch,
  },
  computed: {
    pageTitle: function () {
      if (this.editMode) {
        return this.tos.name;
      } else {
        return Utils.t("tos.titles.default");
      }
    }
  },
  data: () => ({
    editMode: false,
    tos: {
      title: "",
      content: "",
      version: "",
      active: false,
    },
    forceDisplay: false,
    showErrors: {
      title: false,
      content: false,
    }
  }),
  methods: {
    Utils() {
      return Utils;
    },
    validForm: function () {
      FormUtils.hideAllErrors(this);
      this.$validator
        .validateAll()
        .then(() => {
          if (this.tos.content === "" || this.tos.content === "<p></p>") {
            this.showErrors.content = true;
            var errorBag = this.$validator.errorBag;
            errorBag.errors.push({
              field: "content",
              msg: "Le contenu est obligatoire",
              rule: "required",
              scope: "__global__",
            });
            FormUtils.showAllErrors(this);
          } else {
            this.saveForm();
          }
        })
        .catch((error) => {
          FormUtils.showAllErrors(this);
        });
    },
    saveForm: function () {
      window.Vfc.$refs.loading.show();

      var tos = { ...this.tos };
      tos.active = this.tos.active ? "1" : "0";
      tos.force_display = this.forceDisplay ? "1" : "0";

      axios
        .put(API.route(API.endpoints.tos.edit, {}), tos)
        .then((response) => {
          window.Vfc.$refs.messages.sendMessage(
            "success",
            Utils.t("global.dataSaved")
          );
          window.Vfc.$refs.loading.hide();
        })
        .catch((error) => {
          if (error.response != null) {
            var errorBag = this.$validator.errorBag;
            if (error.response.status == 422) {
              FormUtils.handleErrors(errorBag, error.response.data.message);
            }
            FormUtils.showAllErrors(this);
          } else {
          }
          window.Vfc.$refs.loading.hide();
        });
    },
    hideError: function (key) {
      FormUtils.hideError(this, key);
    },
    contentEditorUpdated(val) {
      this.tos.content = val;
    }
  },
  mixins: [clickaway],
  created() {},
  mounted() {
    if (!useDvFlagAccess("beepiz-cgu-can:read")) {
      this.$router.push({ name: "AccessDenied", params: { slug: "tos" } });
    } else {
      let promise = axios
        .get(API.route(API.endpoints.tos.show))
        .then((response) => {
          this.tos = { ...response.data };
          this.$refs.editor.setContent(this.tos.content);
          window.Vfc.$refs.loading.hide();
        })
        .catch((error) => {
          this.forceDisplay = true;
          window.Vfc.$refs.loading.hide();
          if (404 === error.response.status) {
            return;
          }
        });
    }
  },
};
</script>

<style lang="scss">
.actions-tos {
  & > ul {
    & > li {
      text-align: right;

      & > span {
        line-height: 13px;
        font-size: 12px;
        display: inline-block;
        width: 200px;
        white-space: normal;
        text-align: left;
        vertical-align: middle;
        padding-left: 5px;
      }
    }
  }
}
</style>
